import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  isAzam,
  UpdateLoadedVorvertraege,
} from '@ps20-frontend/shop-integration-redux';
import { App, determineAssekuranztarif } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../localStore';

export function* watchUpdateAssekuranztarif() {
  yield takeEvery(GlobalActions.UPDATE_VORVERTRAEGE, safeSaga(updateAssekuranztarif, App.SHOP));
}

export function* updateAssekuranztarif(action: GlobalAction<UpdateLoadedVorvertraege>) {
  const state: IAppState = yield select();
  if (state.transientState.avLoaded || isAzam(state.transientState.role)) {
    yield cancel();
  }
  const assekuranztarif: boolean = determineAssekuranztarif(
    action.payload.standardVorvertraege,
    action.payload.standaloneVorvertraege,
  );
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put,
    new GlobalActions().updateAssekuranztarifDataAfterVorvertraegeLoad(assekuranztarif),
  );
}
